import {inject, Injectable} from "@angular/core";
import { UserLNGType } from "src/swagger-gen/lng/models";
import { UserSessionService } from "../tinea-components/okta/services/session/user-session.service";

@Injectable({
  providedIn: 'root',
})
export class RightService {
    private readonly userSessionService = inject(UserSessionService);

    private get user() {
        return this.userSessionService.getUser();
    }
    
    // --------------------------------------------------------------------- //
    //                          can access "feature"                         //
    // --------------------------------------------------------------------- //
    // Check if the user connected can access to Administration pages
    public canAccessAdministration(): boolean {
        return this.user.type === UserLNGType.ADMIN_LNG
            || this.user.type === UserLNGType.FINANCE_LNG
            || this.user.type === UserLNGType.LOGISTIC_LNG;
    }

    // Check if the user connected can access to Logistic pages
    public canAccessLogistic(): boolean {
        return this.user.type === UserLNGType.ADMIN_LNG
            || this.user.type === UserLNGType.LOGISTIC_LNG
            || this.user.type === UserLNGType.ENGINEER_LNG;
    }

    // Check if the user connected can access to PreInvoice pages
    public canAccessLogisticPreInvoice(): boolean {
        return this.user.type === UserLNGType.ADMIN_LNG
            || this.user.type === UserLNGType.LOGISTIC_LNG;
    }



    // Check if the user connected can access Deliveries
    public canAccessDeliveries(): boolean {
        return this.user.type === UserLNGType.ADMIN_LNG
            || this.user.type === UserLNGType.LOGISTIC_LNG
            || this.user.type === UserLNGType.ENGINEER_LNG
            || this.user.type === UserLNGType.OPERATOR_LNG;
    }

    // Check if the user connected can access to Finance pages
    public canAccessFinance(): boolean {
        return this.user.type === UserLNGType.ADMIN_LNG
            || this.user.type === UserLNGType.FINANCE_LNG;
    }
}
